import React from "react";
import { Badge, Button, Card } from "react-bootstrap";

function AddressCard({ address, isSelected, onSelect, onEdit, onSetDefault }) {
  return (
    <Card
      onClick={() => onSelect(address)}
      style={{
        cursor: "pointer",
        border: isSelected ? "2px solid #1890ff" : "1px solid #D9D9D9",
        backgroundColor: isSelected ? "#e6f7ff" : "#fff",
        borderRadius: 8,
        transition: "all 0.2s",
      }}
      className="mb-2 p-2"
    >
      <Card.Body className="p-2">
        <div className="d-flex justify-content-between align-items-start">
          <div style={{ flex: 1 }}>
            <div className="fw-semibold" style={{ fontSize: 14 }}>
              {address.address1}
            </div>
            {address.address2 && (
              <div className="text-muted" style={{ fontSize: 13 }}>
                {address.address2}
              </div>
            )}
            <div className="text-muted" style={{ fontSize: 13 }}>
              {address.city}, {address.province} - {address.zip}
            </div>
            <div className="text-muted" style={{ fontSize: 13 }}>
              {address.country}
            </div>
          </div>
          <div className="d-flex flex-column align-items-end gap-1">
            <div className="d-flex gap-1">
              {address.is_default && (
                <Badge bg="primary" style={{ fontSize: 10 }}>
                  Default
                </Badge>
              )}
              {isSelected && (
                <Badge bg="warning" text="dark" style={{ fontSize: 10 }}>
                  Selected
                </Badge>
              )}
            </div>
            <div className="d-flex gap-1">
              <Button
                size="sm"
                variant="outline-primary"
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit(address);
                }}
                style={{ fontSize: 11, padding: "2px 8px" }}
              >
                Edit
              </Button>
              {!address.is_default && (
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={(e) => {
                    e.stopPropagation();
                    onSetDefault(address);
                  }}
                  style={{ fontSize: 11, padding: "2px 8px" }}
                >
                  Set Default
                </Button>
              )}
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default AddressCard;
